/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "服务链接可以拖拽改变顺序",
        type: "tips"
    },
    {
        name: "服务",
        type: "module-name"
    },
    {
        key: "style_type",
        name: "样式",
        type: "radio-box-img",
        width: 84,
        "radio-list": [{
                url: "https://img.mockuai.com/tms/2018/1/10/upload_45d9acc229960a30ca9b14ab951d0986.png",
                value: 1,
                text: "双列"
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/10/upload_c9b8a668b7812c4277a638986eab1e93.png",
                value: 2,
                text: "小图单列"
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/10/upload_337f6d48a136bd004a3cee76b951572f.png",
                value: 3,
                text: "大图单列"
            },
            {
                url: "https://img.mockuai.com/tms/2018/1/10/upload_0e22c83e15505e62389bcc0d9868a458.png",
                value: 4,
                text: "滑动"
            }
        ]
    },
    {
        key: "link_data",
        name: "链接",
        type: "service-list"
    }
];
export default config;